import React from "react";
import styled, { css } from "styled-components";
import { IPageProps } from "./interfaces";

export const Progress = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StyledTick = styled.svg`
    stroke: ${p => p.theme.c.active};
    stroke-width: 2px;
    position: relative;
    top: 3px;
    margin-left: 6px;
`;

export const Page = styled.div<IPageProps>`
    font-size: 16px;
    font-weight: 600;
    color: ${p => p.theme.c.grey7};
    padding: 6px;
    min-width: 75px;
    text-align: center;
    ${p =>
        p.active
            ? css`
                  color: ${p => p.theme.mode === "dark" ? p.theme.c.whiteOnActive : p.theme.c.dark};
                  border-bottom: solid 3px ${p => p.theme.c.boost};
              `
            : undefined}

    ${p =>
        p.completed
            ? css`
                  color: ${p => p.theme.c.active};
              `
            : undefined}
`;

export const PageWrapper = styled.div`
    margin-top: 16px;
`;

export const Tick = () => (
    <StyledTick width="18" height="18" viewBox="0 0 15 15">
        <polygon points="1.5,6.5 5,10 12,3 5,10" />
    </StyledTick>
);
